import { render, staticRenderFns } from "./commentEdit.vue?vue&type=template&id=f3952450&"
import script from "./commentEdit.vue?vue&type=script&lang=ts&"
export * from "./commentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports